

export const bulkTransferStatusDropdown = [
  { label: 'COMPLETED', value: 'COMPLETED' },
  // { label: 'Failed', value: 'FAILED' },
  { label: 'PROCESSING', value: 'PROCESSING' },
]



export const EMPTY_FILTER_FORM = {
  // "serviceType": "BULK_TRANSFER",
  "paymentMode": [],       
  "uploadedBy": null, 
  "processInstanceId" : null,
  fromProcessingDate: null,
  toProcessingDate: null,
  status:[]
}

export const bulkPaymentTransferUploadStatusInfoMap = {
    "COMPLETED" : {text : 'COMPLETED' , bgColor: "#BBE2CE", textColor: "#0B442D" },
    "FAILED" : {text : 'Failed' , bgColor: "#F9D9D7", textColor: "#B32306" },
    "PROCESSING" : {text : 'In Progress' , bgColor: "#FFEDC8", textColor: "#705010" },
}

